import { useIntl } from 'react-intl';

import { Button } from '@calm-web/design-system';

import deviceImages from '@/../public/_n/images/family-plan/family-devices.png';
import { FamilyPlanLandingProps } from '@/components/familyPlan/FamilyPlanLanding/types';
import Image from '@/components/image/NextImage';
import GridWrapper from '@/components/ui/GridWrapper';
import { useFormattedCurrency } from '@/hooks/purchase';
import { usePricesState } from '@/hooks/store';

import messages from './messages';
import { ButtonWrapper, Content, DeviceImageWrapper, Heading, Subheading, Wrapper } from './styles';

const Hero = ({ onClick, adminName, isJoinFlow }: FamilyPlanLandingProps) => {
	const prices = usePricesState();
	const { formatMessage } = useIntl();
	const formatCurrency = useFormattedCurrency();

	const getHeading = () => {
		if (!isJoinFlow) {
			return formatMessage(messages.heading);
		}

		if (adminName) {
			return formatMessage(messages.headingAccept, {
				name: adminName,
			});
		}

		return formatMessage(messages.headingAcceptNoName);
	};

	const localizedPrice = formatCurrency(prices?.current?.family, prices.pricing_format.currency);

	return (
		<Wrapper>
			<GridWrapper columns={4}>
				<Content>
					<Heading>{getHeading()}</Heading>
					<Subheading>
						{isJoinFlow
							? formatMessage(messages.subheadingAccept)
							: formatMessage(messages.subheading, {
									price: localizedPrice,
							  })}
					</Subheading>
					<ButtonWrapper>
						<Button
							fullWidth
							backgroundColor="white"
							textColor="gray8"
							onPress={() =>
								onClick &&
								onClick({
									section: 'hero',
									copy: isJoinFlow ? messages.ctaAccept.defaultMessage : messages.cta.defaultMessage,
								})
							}
						>
							{formatMessage(isJoinFlow ? messages.ctaAccept : messages.cta)}
						</Button>
					</ButtonWrapper>
				</Content>
				<DeviceImageWrapper>
					<Image layout="responsive" objectFit="cover" alt="Calm app on phone" src={deviceImages} />
				</DeviceImageWrapper>
			</GridWrapper>
		</Wrapper>
	);
};

export default Hero;
